'use strict';

var React = require('react');
var styleHelper = require('../../helper/styleHelper');
var DashBorder = require('../common/LineModeBorder');
var _ = require('underscore');

/*
 @Author : mengxiaojiang
 @CreateDate : 2016-3-29
 @Descript : 面板组件
 */
var Panel = React.createClass({
  render: function () {
    var borderProp = _.extend({}, this.props.items[this.props.items.length - 1]);
    //borderProp.borderColor = this.props.borderColor;
    borderProp.w = styleHelper.getWidth(this.props);
    borderProp.h = styleHelper.getHeight(this.props);
    borderProp.zIndex = borderProp.zOrder || this.props.items.length;

    var panelStyle = {border: 'none', width: '100%', height: '100%'};
    styleHelper.StyleUtil(this.props, panelStyle).base().background();
    return (<div
      id={this.props.controlID}
      key={this.props.controlID}
      className="component component-panel"
      style={panelStyle}
    >
      <div style={{
        width: '100%',
        height: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
        border: 'none',
        zIndex: 0,
        overflow: 'hidden'
      }}>
        {this.props.children}
      </div>
      <DashBorder {...borderProp}/>
    </div>);
  }
});
module.exports = Panel;



// WEBPACK FOOTER //
// ./src/views/Components/Panel.jsx